import i18n from 'i18next';
import { reactI18nextModule } from 'react-i18next';

import svLocale from '../../locales/sv.json';

i18n
  .use(reactI18nextModule)
  .init({
      fallbackLng: 'sv',

      defaultNS: 'common',

      interpolation: {
          escapeValue: false, // not needed for react!!
      },

      react: {
          wait: true,
      },

      resources: {
          sv: svLocale,
      },
  });


export default i18n;



/** WEBPACK FOOTER **
 ** /src/shared/service/i18n.js
 **/